import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./commonResource/css/styles.css";
import "./commonResource/css/bootstrap.css";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Main from "./Main/Main";
import YoutubeVideos from "./Youtube/YoutubeVideos";



import Iphone from "./RoutingComponents/iphone/Iphone";

import SingleAppleProduct from "./RoutingComponents/productPage/SingleAppleProduct";
import Four04 from "./RoutingComponents/Four04/Four04";
import SectionOne from "./SectionOne/SectionOne";
import SectionTwo from "./Components/SectionTwo/SectionTwo";
import SectionFive from "./SectionFive/SectionFive";




function App() {
  return (
    <div>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/ipad" element={<SectionOne />} />
          <Route path="/Mac" element={<SectionTwo />} />
          <Route path="/iphone" element={<Iphone />} />
           <Route path="/watch" element={<SectionFive />} /> 
          <Route path="/iphone/:productID" element={<SingleAppleProduct />} />
          <Route path="*" element={<Four04 />} />
        </Routes>
        <YoutubeVideos />

        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
